import { createContext } from 'react'

const PopupContext = createContext({
    currentPopup: [],
    setCurrentPopup: () => {},
})

export default PopupContext